import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    name: 'Mariana L.',
    role: 'Dueña de Estudio en CABA',
    text: 'Tenía miedo de invertir en barras y que no funcionara. Este pack me dio la claridad exacta de cuánto cobrar y cómo venderlo. Llené los cupos antes de inaugurar.'
  }, {
    name: 'Julieta S.',
    role: 'Instructora y Dueña en Córdoba',
    text: 'La estructura de las clases es espectacular. Mis alumnas de pilates están fascinadas con la intensidad del barre. ¡Súper recomendable!'
  }, {
    name: 'Florencia M.',
    role: 'Estudio Boutique en Rosario',
    text: 'Lo mejor es que está pensado para Argentina. Los consejos de finanzas y marketing son reales y aplicables hoy. Recuperé la inversión con la primera alumna.'
  }, {
    name: 'Carolina G.',
    role: 'Dueña de Estudio en Mendoza',
    text: 'No tenía tiempo para hacer una formación de 6 meses. Este material va directo al grano. En 3 semanas ya estaba dando mi primera clase de barre.'
  }, {
    name: 'Agustina P.',
    role: 'Estudio de Pilates en La Plata',
    text: 'Las planillas financieras y los guiones de venta valen oro. Me ahorraron meses de prueba y error. El mejor material que compré para mi estudio.'
  }, {
    name: 'Romina V.',
    role: 'Dueña de Estudio en Mar del Plata',
    text: 'Sumé barre y se convirtió en mi clase más pedida en menos de un mes. El kit de comunicación para redes me ahorró un montón de trabajo y las inscripciones llegaron solas.'
  }, {
    name: 'Sofía B.',
    role: 'Estudio de Pilates en Neuquén',
    text: 'Pensaba que necesitaba un espacio enorme y una gran inversión. El pack me mostró cómo arrancar con lo que ya tenía. Hoy el barre es lo que más me diferencia en la zona.'
  }];
  return <section className="py-14 bg-barre-blush overflow-hidden" data-id="element-147">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
        <div className="text-center mb-8" data-id="element-149">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3" data-id="element-150">
            Dueñas de estudios que ya evolucionaron
          </h2>
          <div className="flex justify-center gap-1 text-barre-pink" data-id="element-151">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-152" />)}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-153">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white p-5 rounded-2xl shadow-sm border border-barre-border relative" data-id="element-154">
              <Quote className="absolute top-4 right-4 w-6 h-6 text-barre-blushDark" data-id="element-155" />
              <p className="text-gray-700 text-sm mb-4 relative z-10 italic" data-id="element-156">
                "{testimonial.text}"
              </p>
              <div data-id="element-157">
                <p className="font-bold text-gray-900 text-sm" data-id="element-158">
                  {testimonial.name}
                </p>
                <p className="text-xs text-barre-pink font-medium" data-id="element-159">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};